import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';

// Vendor modules
import { NgxPaginationModule } from 'ngx-pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

export const COMMON_IMPORTS = [
    CommonModule,
    FormsModule,
    HttpClientModule,
    TooltipModule.forRoot(),
    NgxPaginationModule,
    NgSelectModule,
];
